import * as React from 'react';

export interface KeyboardSubmitShortcutState {
    isCtrlPressed: boolean;
    submitLabel: string;
    defaultLabel: string;
}

export const useKeyboardSubmitShortcut = (
    defaultLabel: string,
    submitLabel: string,
): KeyboardSubmitShortcutState => {
    const [isCtrlPressed, setIsCtrlPressed] = React.useState(false);

    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Control') {
                setIsCtrlPressed(true);
            }
        };

        const handleKeyUp = (event: KeyboardEvent) => {
            if (event.key === 'Control') {
                setIsCtrlPressed(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    return {
        isCtrlPressed,
        submitLabel: isCtrlPressed ? submitLabel : defaultLabel,
        defaultLabel,
    };
};
